import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';

/**
 * Screen-reader + keyboard support for client-side navigation: after the route (path) changes, the
 * new document title is announced in a polite live region and focus moves to `<main>` so keyboard
 * users continue from the new content instead of from the link they just activated.
 * Hash-only and query-only changes are left alone (in-page anchors keep their own scroll/focus).
 */
export function RouteAnnouncer() {
  const { pathname } = useLocation();
  const previous = useRef(pathname);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (previous.current === pathname) return;
    previous.current = pathname;

    // Wait a frame so the new route's <Seo> has updated document.title.
    const frame = window.requestAnimationFrame(() => {
      setMessage(document.title);
      if (window.location.hash === '') {
        document.getElementById('main')?.focus({ preventScroll: true });
      }
    });
    return () => {
      window.cancelAnimationFrame(frame);
    };
  }, [pathname]);

  return (
    <div className="sr-only" role="status" aria-live="polite" aria-atomic="true">
      {message}
    </div>
  );
}
